import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Hero from "components/hero/Hero.js";
import Footer from "components/footers/FiveColumnDark";
import EmployeeDetails from "components/cards/EmployeeDetails";
import GlobalStyle from "helpers/GlobalStyle";
import SplashAnimationContainer from "helpers/SplashAnimationContainer";
import useScreenSize from "helpers/useScreenSize";
const BgWrapper = styled.div`
  ${tw`fancy-feature-mask`}
`;
export default () => {
  const { isXs } = useScreenSize();

  return (
    <div style={{ marginTop: "50px" }}> 
      <GlobalStyle />
      <Hero isXs={isXs} />
      <SplashAnimationContainer>
        {isXs ? (
          <EmployeeDetails isXs={isXs} />
        ) : (
          <BgWrapper>
            <EmployeeDetails />
          </BgWrapper>
        )}
        <Footer isXs={isXs} />
      </SplashAnimationContainer>
    </div>
  );
};
